import { Fragment, memo } from 'react';

import { useRouter } from 'react-resource-router';

import { RouteContext } from 'src/router/routes/types';

import { NavSystem } from './nav-system';

export const UniversalNavigation = memo(() => {
  const [routerState] = useRouter();
  const { route } = routerState as RouteContext;
  const RouteLayout = route?.layout || Fragment;

  return (
    <Fragment>
      <RouteLayout />
      <NavSystem />
    </Fragment>
  );
});
